import React from "react";
import "./ExcoSkeletonCard.css";

const ExcoSkeletonCard = () => {
  return (
    <div className="exco-skeleton-card">
      {/* Card Header Skeleton */}
      <div className="exco-skeleton-header">
        <div className="exco-skeleton-title"></div>
        <div className="exco-skeleton-button"></div>
      </div>

      {/* Card Body - 4 Sections */}
      <div className="exco-skeleton-body">
        {/* Section 1 */}
        <div className="exco-skeleton-section">
          <div className="exco-skeleton-section-header"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
        </div>

        {/* Section 2 */}
        <div className="exco-skeleton-section">
          <div className="exco-skeleton-section-header"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
        </div>

        {/* Section 3 */}
        <div className="exco-skeleton-section">
          <div className="exco-skeleton-section-header"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
        </div>

        {/* Section 4 */}
        <div className="exco-skeleton-section">
          <div className="exco-skeleton-section-header"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
          <div className="exco-skeleton-item"></div>
        </div>
      </div>
    </div>
  );
};

const ExcoSkeletonLoading = ({ count = 3 }) => {
  return (
    <div className="exco-skeleton-container">
      {Array.from({ length: count }).map((_, index) => (
        <ExcoSkeletonCard key={index} />
      ))}
    </div>
  );
};

export default ExcoSkeletonLoading;
